module.exports = __webpack_public_path__ + "static/sol-section-4-img-bbe81d1123fef82b7384b6a8fcec2acc.png";